var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M767.999 213.334h-394.166l-68.333-85.333h462.499c70.568 0 127.998 57.43 127.998 127.999v383.999h128.004l-170.666 213.332-170.671-213.332h128.004v-383.999c0-23.551-19.156-42.666-42.668-42.666zM0 384.001l170.666-213.333 170.666 213.333h-127.999v384.001c0 23.55 19.157 42.662 42.667 42.662h394.166l68.335 85.336h-462.502c-70.571 0-128-57.43-128-127.998v-384.001h-127.999z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.094061a6b740b762dce7e9cf24477eb4.svg";
export { ForwardRef as ReactComponent };